import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export const FormSuccessScreen = ({ onEdit, t }) => (
  <Box sx={{ maxWidth: 800, mx: "auto", mb: 4 }}>
    <Card
      elevation={0}
      sx={{
        border: "1px solid #dfdfdf",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.03)",
        textAlign: "center",
      }}
    >
      <CardContent sx={{ px: { xs: 3, sm: 5 }, py: { xs: 6, sm: 8 } }}>
        <Box
          sx={{
            width: 88,
            height: 88,
            borderRadius: "50%",
            backgroundColor: "#163666",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
            animation: "sibo-success-pop 0.4s ease-out",
            "@keyframes sibo-success-pop": {
              "0%": { transform: "scale(0)", opacity: 0 },
              "60%": { transform: "scale(1.15)", opacity: 1 },
              "100%": { transform: "scale(1)" },
            },
          }}
        >
          <Box component="svg" viewBox="0 0 52 52" sx={{ width: 44, height: 44 }}>
            <Box
              component="path"
              fill="none"
              stroke="#ffffff"
              strokeWidth={4}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14 27l7 7 17-17"
              sx={{
                strokeDasharray: 50,
                strokeDashoffset: 50,
                animation: "sibo-success-draw 0.5s 0.35s ease-out forwards",
                "@keyframes sibo-success-draw": {
                  to: { strokeDashoffset: 0 },
                },
              }}
            />
          </Box>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 800, mb: 1.5, color: "#1a1a2e" }}>
          {t.thankYou}
        </Typography>
        <Typography variant="body2" sx={{ color: "#6b7280", mb: 4 }}>
          {t.formSubmittedSuccessfully}
        </Typography>

        <Button
          onClick={onEdit}
          variant="outlined"
          startIcon={<EditOutlinedIcon />}
          sx={{ borderRadius: 1.5, borderColor: "#163666", color: "#163666" }}
        >
          {t.editSubmission}
        </Button>
      </CardContent>
    </Card>
  </Box>
);
